import {
  ItemIds,
  LayoutColumnsDefinition,
  LayoutListDefinition,
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  TEXT,
  TWEET
} from '../items';
import { ItemDefinition } from '../items/Item';
import { Translator } from '../Translator';
import { translate } from './translate';

export const SocialMedia2: Translator = sequence => {
  const root = translate(sequence, () => null);
  const leftSide: ItemDefinition<ItemIds>[] = [];
  const rightSide: ItemDefinition<ItemIds>[] = [];

  sequence.items?.forEach(item => {
    if (item.__typename === 'Card') {
      leftSide.push({
        type: TWEET,
        id: 'tweet',
        values: {
          editableCardId:
            sequence.personalization && sequence.companyName
              ? undefined
              : item.id,
          pic:
            sequence.personalization && sequence.logoUrl
              ? sequence.logoUrl
              : item?.pictures && item?.pictures.length >= 0
                ? item?.pictures[0]?.mediaUrl
                : false,
          name:
            sequence.personalization && sequence.companyName
              ? sequence.companyName
              : item.title,
          alias:
            sequence.personalization && sequence.companyName
              ? '@' + sequence.companyName.replace(/ /g, '')
              : item.subtitle
        },
        items: [
          {
            type: TEXT,
            id: `body_${item.id}`,
            items: [],
            values: {
              value: item.body
            }
          }
        ]
      });
    }

    if (item.__typename === 'Text') {
      rightSide.push({
        type: TEXT,
        id: `${item.id}_subtitle`,
        items: [],
        values: {
          value: item.subtitle || 'QUIZ',
          variant: 'sub_heading',
          icon: item.icon
        }
      });

      rightSide.push({
        type: TEXT,
        id: `${item.id}_title`,
        items: [],
        values: {
          value: item.title || '',
          variant: 'heading2'
        }
      });

      rightSide.push({
        type: TEXT,
        id: `${item.id}_body`,
        items: [],
        values: {
          value: item.body || ''
        }
      });
    }
  });

  if (rightSide && rightSide.length) {
    root.items.push({
      id: `${sequence.id}-columns`,
      type: LAYOUT_COLUMNS,
      items: [
        leftSide[0],
        {
          id: 'list',
          type: LAYOUT_LIST,
          values: { align: 'left', height: { _: 'auto', lg: '100%' } },
          items: rightSide
        } as LayoutListDefinition
      ]
    } as LayoutColumnsDefinition);
  } else {
    const tweet = leftSide[0];
    tweet.values = {
      ...(tweet.values as Record<string, unknown>),
      width: { _: '95%', md: '50%' }
    };

    root.items.push({
      id: `${sequence.id}-columns`,
      type: LAYOUT_COLUMNS,
      items: [tweet]
    } as LayoutColumnsDefinition);
  }

  return root;
};
